module.exports = __webpack_public_path__ + "static/img/YD300.e949509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YD300.png
// module id = JqkZ
// module chunks = 2